<template lang="pug">
  v-combobox.sud-combobox( 
    :value="value"
    :label="label" 
    :items="items" 
    :search-input.sync="newTag" 
    :hide-no-data="!newTag"
    :item-text="itemText" 
    item-color="error"
    :rules="rules"
    return-object
    :multiple="!single"
    small-chips 
    hide-selected 
    deletable-chips 
    outlined 
    light
    menu-props="closeOnContentClick" 
    @input="handleInput"
  )
    template(v-slot:no-data)
      v-list-item
        | Нажмите "<strong>ENTER</strong>", чтобы добавить
        v-chip.ml-2(v-if="selectable" color="#00BCD4" label) {{ newTag }}
        strong.ml-2(v-else) {{ newTag }}

    template(v-if="selectable" v-slot:selection="{ attrs, item, parent }")
      v-chip(v-bind="attrs" :color="getColor(item)" :text-color="getTextColor(item)" small close @click="select(item)" @click:close="parent.selectItem(item)")
        span.pr-2 {{ item === Object(item) ? item[itemText] : item }}
</template>

<script>
export default {
  name: 'app-combobox',
  props: {
    value: Array,
    items: {
      type: Array,
      default: () => []
    },
    label: String,
    itemText: String,
    rules: [Object, Array],
    single: Boolean,
    selectable: Boolean,
    activeItem: {
      type: [String, Object],
      default: null
    }
  },
  data () {
    return {
      newTag: null,
    }
  },
  methods: {
    handleInput (event) {
      this.$emit('input', event)
    },

    getColor (item) {
      return item === this.activeItem ? '#19AFDE' : '#e0e0e0'
    },

    getTextColor (item) {
      return item === this.activeItem ? 'white': 'rgba(0, 0, 0, 0.87)'
    },

    select (item) {
      if (this.selectable) this.$emit('select', item)
    }
  },
}
</script>

<style>
.v-chip.v-size--small {
  height: inherit;
  min-height: 24px;
}
</style>
